import { render, staticRenderFns } from "./constructionRelactionTaskWorkPermit.vue?vue&type=template&id=3e147d8e"
import script from "./constructionRelactionTaskWorkPermit.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTaskWorkPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e147d8e')) {
      api.createRecord('3e147d8e', component.options)
    } else {
      api.reload('3e147d8e', component.options)
    }
    module.hot.accept("./constructionRelactionTaskWorkPermit.vue?vue&type=template&id=3e147d8e", function () {
      api.rerender('3e147d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTaskWorkPermit.vue"
export default component.exports